export const Footer = () => (
  <footer
    data-testid="footer"
    className="mx-auto w-full max-w-[1440px] border-t border-ink/10 px-4 py-10 sm:px-6 lg:px-10"
  >
    <div className="flex flex-col items-center gap-4 text-center">
      <img src="/images/dachshund-mark.png" alt="" aria-hidden className="h-5 w-auto opacity-80" />
      <p className="font-serif text-lg font-medium tracking-tight text-ink">
        My Dachshund Days
      </p>
      <a
        href="mailto:hello@mydachshunddays.com"
        data-testid="footer-email-link"
        className="text-[13px] font-medium tracking-wide text-ink/60 underline-offset-4 transition-colors hover:text-ink hover:underline"
      >
        hello@mydachshunddays.com
      </a>
      <p className="text-[11px] uppercase tracking-[0.24em] text-ink/40">
        © {new Date().getFullYear()} My Dachshund Days
      </p>
    </div>
  </footer>
);
